import { useEffect } from "react"
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks"
import { GetAllBioSuisse, setEditCertificateDate, setEditCertificateExpires, setEditCertifiedProducts, setEditCondition, setEditDepartureProtocolSend, setEditEntryProtocolRequest, setEditEntryProtocolResponse, setEditIdSelectedCert, setEditInspectionVisitId, setEditNote, setEditNoteCondition, setEditResult } from "./slice"
import { formatterDate } from "../../../utils"
import { EditIcon } from "../../../ui/icons/edit"
import { useNavigate } from "react-router-dom"
import { EditCertBioSuisseDTO } from "./dataService/dto"

export function GestioneBiosuisseList() {
    const dispatch = useAppDispatch()
    const sessionState = useAppSelector(state => state.session)
    const bioSuisse = useAppSelector(state => state.bioSuisse)
    const navigate = useNavigate()

    useEffect(() => {
        if (sessionState.selected.customerId) {
            dispatch(GetAllBioSuisse({ customerId: sessionState.selected.customerId, page: 0, itemsPerPage: 0 }))
        }
    }, [dispatch, sessionState.selected.customerId])

    const handleOnEdit = (certBio: EditCertBioSuisseDTO) => {
        dispatch(setEditEntryProtocolRequest(certBio.certificationRequestId))
        dispatch(setEditResult(certBio.result))
        dispatch(setEditInspectionVisitId(certBio.inspectionVisitId))
        dispatch(setEditDepartureProtocolSend(certBio.sendingChecklistId))
        dispatch(setEditEntryProtocolResponse(certBio.bioSuisseCertificateId))
        dispatch(setEditNote(certBio.note))
        dispatch(setEditCertifiedProducts(certBio.certificatedProducts))
        dispatch(setEditCertificateDate(certBio.validityStartingDate))
        dispatch(setEditCertificateExpires(certBio.validityEndingDate))
        dispatch(setEditCondition(certBio.condition))
        dispatch(setEditNoteCondition(certBio.certificationConditionsDetail))
        dispatch(setEditIdSelectedCert(certBio.id))

        navigate('/editBiosuisse')
    }

    return (
        <div className="w-full overflow-x-auto rounded-xl border border-neutral-200 shadow-sm">
            <table id="users-table" className="w-full border-collapse text-text-md">
                <thead>
                    <tr className="bg-brandPrimary-600 text-white uppercase text-xs tracking-wide h-[52px]">
                        <th className="px-3 py-3 text-center font-semibold whitespace-nowrap rounded-tl-xl w-[60px]">#</th>
                        <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Data Certificato</th>
                        <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Data Scadenza</th>
                        <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Visita</th>
                        <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Prot. Invio Doc.</th>
                        <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Prot. Richiesta</th>
                        <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Prodotti Certificati</th>
                        <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Esito</th>
                        <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Note Esito</th>
                        <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Condizioni</th>
                        <th className="px-3 py-3 text-left font-semibold whitespace-nowrap rounded-tr-xl">Note Condizioni</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        bioSuisse.getAllCertificatesResponse?.data?.length ?
                            bioSuisse.getAllCertificatesResponse.data.map((pre, index) =>
                                <tr
                                    key={pre.id || index}
                                    className={`text-left border-b border-neutral-200 transition-colors duration-150 hover:bg-brandPrimary-50 ${index % 2 === 0 ? 'bg-white' : 'bg-neutral-50'}`}
                                >
                                    <td className="px-3 py-2 text-center">
                                        <button className="relative group p-1 rounded hover:bg-neutral-100 transition-colors" onClick={() => handleOnEdit(pre)}>
                                            <EditIcon color='orange' size={20} />
                                        </button>
                                    </td>
                                    <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{formatterDate(pre.validityStartingDate)}</td>
                                    <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{formatterDate(pre.validityEndingDate)}</td>
                                    <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{pre.inspectionVisitId || '-'}</td>
                                    <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{pre.sendingChecklistId || '-'}</td>
                                    <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{pre.certificationRequestInfo || '-'}</td>
                                    <td className="px-3 py-2 text-neutral-700">{pre.certificatedProducts || '-'}</td>
                                    <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{pre.result || '-'}</td>
                                    <td className="px-3 py-2 text-neutral-700">{pre.note || '-'}</td>
                                    <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{pre.certificationConditions === true ? 'Si' : pre.certificationConditions === false ? 'No' : '-'}</td>
                                    <td className="px-3 py-2 text-neutral-700">{pre.certificationConditionsDetail || '-'}</td>
                                </tr>
                            )
                            : (
                                <tr>
                                    <td colSpan={11} className="px-3 py-3 text-left text-neutral-500 bg-white">
                                        Nessuna certificazione BioSuisse trovata
                                    </td>
                                </tr>
                            )
                    }
                </tbody>
            </table>
            </div>
    )
}